import { INavData } from "@coreui/angular";


export const navSuperAdminItems: INavData[] = [

  {
    name: "Dashboard",
    url: "Dashboard",
    iconComponent: { name: "cil-speedometer" },
    // badge: {
    //   variant: 'info',
    //   text: '15'
    // },
    children: [
      {
        name: "Statistic",
        url: "/dashboard",
        icon: "nav-icon-bullet",
      },
      {
        name: "Uncompleted Task",
        url: "/performance",
        icon: "nav-icon-bullet",
      },
      {
        name: "Performance",
        url: "/staff-performance-new",
        icon: "nav-icon-bullet",
      }
    ]
  },
  {
    name: "User",
    url: "user",
    iconComponent: { name: "cil-people" },
    children: [
      {
        name: "Staff",
        url: "/staff",
        icon: "nav-icon-bullet",
      },
      {
        name: "Runner",
        url: "/runner",
        icon: "nav-icon-bullet",
      }
    ]
  },
  {
    name: "Sales",
    url: "/sales",
    iconComponent: { name: "cil-dollar" },
  },
  {
    name: "Invoice",
    url: "/invoice",
    iconComponent: { name: "cil-spreadsheet" },
  },
  {
    name: "Quotation",
    url: "/policy",
    iconComponent: { name: "cil-notes" },
  },
  {
    name: "Task",
    url: "/job",
    iconComponent: { name: "cil-task" },
  },
  {
    name: "Renewal",
    url: "Renewal",
    iconComponent: { name: "cil-calendar" },
    children: [
      {
        name: "Motor",
        url: "/renewal",
        icon: "nav-icon-bullet",
      },
      {
        name: "Non-Motor",
        url: "/renewal-non-motor",
        icon: "nav-icon-bullet",
      },
    ]
  },
  {
    name: "Road Tax",
    url: "/road-tax",
    iconComponent: { name: "cil-credit-card" },
  },
  {
    name: "Customer",
    url: "Customer",
    iconComponent: { name: "cil-user" },
    children: [
      {
        name: "Listing",
        url: "/customer",
        icon: "nav-icon-bullet",
      },
      {
        name: "My Favourite",
        url: "/favourite",
        icon: "nav-icon-bullet",
      },
    ]
  },
  {
    name: "Report",
    url: "Report",
    iconComponent: { name: "cil-chart-pie" },
    children: [
      {
        name: "Summary",
        url: "/report-summary",
        icon: "nav-icon-bullet",
      },
      {
        name: "Download",
        url: "/report",
        icon: "nav-icon-bullet",
      },
      {
        name: "Graph",
        url: "/report-graph",
        icon: "nav-icon-bullet",
      },
      {
        name: "Enquiry",
        url: "/report-enquiry",
        icon: "nav-icon-bullet",
      },
      // {
      //   name: "Quotation",
      //   url: "/report-quotation-performance",
      //   icon: "nav-icon-bullet",
      // },
    ]
  },
  {
    name: "Support",
    url: "/support",
    iconComponent: { name: "cil-speech" },
  },
  {
    name: "Settings",
    url: "Settings",
    iconComponent: { name: "cil-settings" },
    children: [
      // {
      //   name: "Product",
      //   url: "/settings/product",
      //   icon: "nav-icon-bullet",
      // },
      {
        name: "Insurance",
        url: "/settings/insurance",
        icon: "nav-icon-bullet",
      },
      {
        name: "Payment Method",
        url: "/settings/payment-gateway",
        icon: "nav-icon-bullet",
      },
      {
        name: "Message Template",
        url: "/settings/message-template",
        icon: "nav-icon-bullet",
      },
      {
        name: "Road Tax",
        url: "/settings/road-tax",
        icon: "nav-icon-bullet",
      },
      {
        name: "Commission",
        url: "/settings/commission",
        icon: "nav-icon-bullet",
      },
      {
        name: "Branch",
        url: "/settings/branch",
        icon: "nav-icon-bullet",
      },
      {
        name: "Account Code",
        url: "/settings/account-code",
        icon: "nav-icon-bullet",
      },
      {
        name: "License",
        url: "/settings/license",
        icon: "nav-icon-bullet",
      },
    ]
  },
];
